var map = {
	"./amazon.svg": "9a7a",
	"./carrefour.svg": "71e0",
	"./costa.svg": "91a7",
	"./currys.svg": "1524",
	"./deliveroo.svg": "b3e9",
	"./gymshark.svg": "f743",
	"./homebase.svg": "c932",
	"./ikea.svg": "7d0b",
	"./just-eat.svg": "097f",
	"./mcdonalds.svg": "366c",
	"./netflix.svg": "b3d8",
	"./pret.svg": "08e0",
	"./prime.svg": "4d86",
	"./puregym.svg": "14ea",
	"./skype.svg": "8f38",
	"./slack.svg": "89e7",
	"./sports-direct.svg": "aa15",
	"./spotify.svg": "0a66",
	"./starbucks.svg": "f329",
	"./tesco.svg": "8e74",
	"./tooltip-icon.svg": "ac1c",
	"./zoom.svg": "3eca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";